export default {"src":"/_next/static/media/san-fran.ff9651b0.svg","height":57,"width":47,"blurWidth":0,"blurHeight":0};